'use client';

import applicationMonitoring from '$utils/monitoring';
import { applyPromisePolyfill } from '@brahma/utils';
import type React from 'react';
import { useEffect } from 'react';

// Apply Promise.withResolvers polyfill for older browsers (Opera 89, Chrome <119, etc.)
// This runs at module load time, ensuring it's available before PDF.js or other code needs it
applyPromisePolyfill();
if (process.env.NEXT_PUBLIC_ENABLE_RUM) {
  applicationMonitoring.init();
}
const MonitoringHelper: React.FC = () => {
  useEffect(() => {
    const handleContextmenu = (e: MouseEvent) => {
      e.preventDefault();
    };
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && (e.key === 'I' || e.key === 'i')) {
        e.preventDefault();
      }
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && (e.key === 'C' || e.key === 'c')) {
        e.preventDefault();
      }
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && (e.key === 'J' || e.key === 'j')) {
        e.preventDefault();
      }
      if ((e.ctrlKey || e.metaKey) && (e.key === 'U' || e.key === 'u')) {
        e.preventDefault();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('contextmenu', handleContextmenu);
    return function cleanup() {
      document.removeEventListener('contextmenu', handleContextmenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  return null;
};
export default MonitoringHelper;